import React from "react";
import * as motion from "motion/react-client";
import { flyUpAnimation } from "../../../utils/animations";

import step1 from "../../../assets/home/step-1.png";
import step2 from "../../../assets/home/step-2.png";
import step3 from "../../../assets/home/step-3.png";
import { useTranslation } from "react-i18next";

interface StepItem {
  icon: string;
  name: string;
  title: string;
  description: string;
}

const StepsSection = () => {
  const { t } = useTranslation();

  const stepsData: StepItem[] = [
    {
      icon: step1,
      name: t("home.steps.step1"),
      title: t("home.steps.step1.title"),
      description: t("home.steps.step1.description")
    },
    {
      icon: step2,
      name: t("home.steps.step2"),
      title: t("home.steps.step2.title"),
      description: t("home.steps.step2.description")
    },
    {
      icon: step3,
      name: t("home.steps.step3"),
      title: t("home.steps.step3.title"),
      description: t("home.steps.step3.description")
    }
  ];

  return (
    <div className="w-full px-2 py-10 flex">
      <div className="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-12 md:gap-10 gap-8">
        {stepsData.map((step, index) => (
          <StepCard key={index} step={step} index={index} />
        ))}
      </div>
    </div>
  );
};

export default StepsSection;

interface StepCardProps {
  step: StepItem;
  index: number;
}

const StepCard: React.FC<StepCardProps> = ({ step, index }) => {
  return (
    <motion.div
      {...flyUpAnimation(index)}
      className="border p-6 flex flex-col gap-4 rounded-2xl w-full justify-start items-center bg-white text-center"
    >
      <p className="text-[#074799] font-bold text-[22px] max-lg:text-lg">
        {step.name}
      </p>

      <div className="bg-[#F4E920] rounded-full w-28 h-28 flex items-center justify-center">
        <img src={step.icon} alt={step.name} />
      </div>

      <p className="text-[#074799] font-bold text-[22px] max-lg:text-lg">
        {step.title}
      </p>

      <p className="text-justify max-lg:text-sm">{step.description}</p>
    </motion.div>
  );
};
